import { actions } from "../actions";

const initialState = {
  user: {},
  isAuth: false,
  userDetails: {},
  userDomains: [],
  userSubDomains: [],
};

export const userReducers = {
  user(state = initialState.user, action) {
    switch (action.type) {
      case actions.VM_SET_USER:
        return action.payload;
      case actions.VM_RESET_USER:
        return {};
      default:
        return state;
    }
  },

  isAuth(state = initialState.isAuth, action) {
    switch (action.type) {
      case actions.VM_SET_AUTH:
        return action.payload;
      case actions.VM_RESET_USER:
        return false;
      default:
        return state;
    }
  },

  userDetails(state = initialState.userDetails, action) {
    switch (action.type) {
      case actions.VM_SET_USER_DETAILS:
        return action.payload;

      case actions.VM_RESET_USER:
        return {};
      default:
        return state;
    }
  },

  userDomains(state = initialState.userDomains, action) {
    switch (action.type) {
      case actions.VM_SET_USER_DOMAINS:
        return action.payload;
      case actions.VM_RESET_USER:
        return [];
      default:
        return state;
    }
  },

  userSubDomains(state = initialState.userSubDomains, action) {
    switch (action.type) {
      case actions.VM_SET_USER_SUB_DOMAINS:
        return action.payload;
      case actions.VM_RESET_USER:
        return [];
      default:
        return state;
    }
  },
};
